import React from 'react';
// import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaJsSquare, FaPython, FaReact, FaNodeJs, FaBootstrap , FaEthereum, FaHardHat } from 'react-icons/fa';
import { DiMongodb, DiCss3, DiMysql } from 'react-icons/di';
import { SiSolidity, SiExpress, SiTailwindcss } from 'react-icons/si';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>Here are languages, frameworks, libraries and protocols on which I can work my magic comfortably.</p>
              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                <div className="item">
                  <FaJsSquare size={100} /> {/* JavaScript */}
                  <h5>JavaScript</h5>
                </div>
                <div className="item">
                  <FaReact size={100} /> {/* React */}
                  <h5>React</h5>
                </div>
                <div className="item">
                <FaEthereum size={100} />
                  <h5>Ethereum</h5>
                </div>
                <div className="item">
                  <FaPython size={100} /> {/* Python */}
                  <h5>Python</h5>
                </div>
                <div className="item">
                  <FaNodeJs size={100} /> {/* Node.js */}
                  <h5>Node.js</h5>
                </div>
                <div className="item">
                  <DiMongodb size={100} /> {/* MongoDB */}
                  <h5>MongoDB</h5>
                </div>
                <div className="item">
                  <DiCss3 size={100} /> {/* CSS */}
                  <h5>CSS</h5>
                </div>
                <div className="item">
                  <FaBootstrap size={100} /> {/* CSS */}
                  <h5>Bootstrap</h5>
                </div>
                <div className="item">
                  <SiTailwindcss size={100} /> {/* CSS */}
                  <h5>Tailwind Css</h5>
                </div>
                {/* Use image placeholders for missing icons */}
                <div className="item">
                  <SiExpress size={100} />
                  <h5>Express.js</h5>
                </div>
                <div className="item">
                <DiMysql size={100} />
                  <h5>SQL</h5>
                </div>
                <div className="item">
                  <SiSolidity size={100} />
                  <h5>Solidity</h5>
                </div>
                <div className="item">
                  <FaHardHat size={100} />
                  <h5>Hardhat</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
